import { Autocomplete, TextField, Tooltip } from "@mui/material";
import styles from "./select.module.css";
import { withStyles } from "@material-ui/styles";
import { ReactNode, useState } from "react";
import OverflowLabel from "../../OverflowLabel";
interface SelectInputProps {
    label?: string;
    mandatory?: boolean;
    showToolTip?: boolean;
    errorMessage?: string;
    helperMessage?: ReactNode;
    disabled?: boolean;
}

const SelectTooltip = withStyles({
    tooltip: {
        backgroundColor: "#173544",
    },
})(Tooltip);

function SelectInput(props: SelectInputProps | any) {
    const {
        errorMessage,
        label,
        showToolTip,
        mandatory,
        helperMessage,
        disabled,
        ...rest
    } = props;
    const [open, setOpen] = useState(false);
    const [selectOpen, setSelectOpen] = useState(false);

    const handleOpenTooltip = () => {
        const { disabled } = props;
        if (showToolTip && !disabled && !selectOpen) setOpen(true);
    };

    const handleCloseTooltip = () => {
        setOpen(false);
    };

    const handleOpenSelect = () => {
        setOpen(false);
        setSelectOpen(true);
    };

    const handleCloseSelect = () => {
        setSelectOpen(false);
    };

    const getLabel = () => {
        const { label } = props;
        let textLabel = "";

        if (label && mandatory) textLabel = label + " *";
        else textLabel = label;

        if (!textLabel || textLabel === "") return null;

        return <OverflowLabel text={textLabel} />;
    };

    let helperText: ReactNode = null;

    if (
        errorMessage !== null &&
        errorMessage !== undefined &&
        errorMessage !== ""
    ) {
        helperText = errorMessage;
    } else {
        helperText = helperMessage;
    }

    const render = () => {
        return (
            <div className={styles["select-input"]}>
                <SelectTooltip
                    open={open}
                    title={props.value?.value}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                >
                    <div
                        onMouseEnter={handleOpenTooltip}
                        onMouseLeave={handleCloseTooltip}
                    >
                        <Autocomplete
                            disabled={disabled}
                            onOpen={handleOpenSelect}
                            onClose={handleCloseSelect}
                            disablePortal
                            disableClearable
                            getOptionLabel={(option: any) => option.value}
                            renderOption={(props, option: any) => {
                                return (
                                    <li {...props} key={option.id}>
                                        {option.value}
                                    </li>
                                );
                            }}
                            autoFocus={false}
                            {...rest}
                            renderInput={(params) => {
                                return (
                                    <TextField
                                        error={
                                            errorMessage !== null &&
                                            errorMessage !== undefined &&
                                            errorMessage !== ""
                                        }
                                        helperText={helperText}
                                        {...params}
                                        InputLabelProps={{ shrink: true }}
                                        label={getLabel()}
                                        autoFocus={false}
                                    />
                                );
                            }}
                        />
                    </div>
                </SelectTooltip>
            </div>
        );
    };

    return render();
}

export default SelectInput;
